import styled from 'styled-components'
import { fontWeights, colors } from '@/styles'

const DetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => width || '100%'};
`

const DetailTitle = styled.p`
  color: ${colors.mediumGrey};
  font-size: 12px;
  line-height: 17px;
  margin: 0;
`

const DetailText = styled.p`
  color: ${colors.darkGrey};
  font-size: 14px;
  font-weight: ${fontWeights.medium};
  line-height: 19px;
  margin: 5px 0 10px 0;
  overflow-wrap: break-word;
  word-break: break-word;
`

const DetailLink = styled(DetailText)`
  cursor: pointer;
  color: ${colors.link};
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`

const LabeledDetail = ({ label, value, width, files }) => {
  return files ? (
    <DetailWrapper width={width}>
      <DetailTitle>{label}</DetailTitle>
      <Wrapper>
        {files.map((f, index) => {
          return (
            <DetailLink onClick={f.onClick} key={index}>
              {f.document_type[0].toUpperCase() + f.document_type.slice(1).replace(/_/g, ' ')}
              {index !== files.length - 1 && ','}
            </DetailLink>
          )
        })}
      </Wrapper>
    </DetailWrapper>
  ) : (
    <DetailWrapper width={width}>
      <DetailTitle>{label}</DetailTitle>
      <DetailText>{value}</DetailText>
    </DetailWrapper>
  )
}

LabeledDetail.defaultProps = {
  label: '',
  value: '',
  width: '100%'
}

export default LabeledDetail
